var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.dataTable === undefined||_vm.dataTable.length===0)?_c('div',{staticClass:"blankBox"},[_vm._v("\n    暂时还没有数据哦～\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }